import { apiGet, apiToken } from "./requests";

export const getDeliveryMethods = () => {
    let path = "shipping-methods/";
    return apiGet(path);
}

export const createDeliveryMethod = (data) => {
    let path = "shipping-methods/";
    return apiToken(data, path, "post");
}

export const updateDeliveryMethod = (data, id) => {
    let path = "shipping-method/" + id;
    return apiToken(data, path, "patch");
}

export const deleteDeliveryMethod = (id) => {
    let path = "shipping-method/" + id;
    return apiToken({}, path, "delete");
}

export const toggleDeliveryMethodStatus = (id, method) => {
    let path;
    if (method === "home") {
        path = "shipping-method/" + id + "/toggle-home-delivery-status";
    } else if (method === "shop") {
        path = "shipping-method/" + id + "/toggle-store-delivery-status";
    }
    
    return apiToken({}, path, "patch");
}